var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth", staticStyle: { padding: "15px" } },
    [
      _vm.isAdmin
        ? _c(
            "el-form",
            { staticClass: "filter-form", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "agency-select-item",
                  staticStyle: { width: "100%" },
                  attrs: { label: "旅行社" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isAdmin ? false : true,
                        filterable: "",
                        placeholder: "請選擇旅行社",
                      },
                      model: {
                        value: _vm.agencyCode,
                        callback: function ($$v) {
                          _vm.agencyCode = $$v
                        },
                        expression: "agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        { staticClass: "filter-form", attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "QA問答內容查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "請輸入QA問答內容" },
                model: {
                  value: _vm.listQueryByChatLog.search,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQueryByChatLog, "search", $$v)
                  },
                  expression: "listQueryByChatLog.search",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getChatLogs },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
          _c(
            "el-button",
            {
              attrs: { type: "success", disabled: !_vm.aiAgentIsEnabled },
              on: { click: _vm.handleDownloadExcel },
            },
            [_vm._v("下載問答紀錄")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", disabled: !_vm.aiAgentIsEnabled },
              on: { click: _vm.handleSetQAPrompt },
            },
            [_vm._v("設定QA內容")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info", disabled: !_vm.aiAgentIsEnabled },
              on: { click: _vm.handleAiQaUi },
            },
            [_vm._v("虛擬人介面設定")]
          ),
          _c("el-switch", {
            staticStyle: { "margin-left": "5px" },
            attrs: { "active-color": "#13ce66", "inactive-color": "#ff4949" },
            on: { change: _vm.handleIsEnabledOnSwitch },
            model: {
              value: _vm.aiAgentIsEnabled,
              callback: function ($$v) {
                _vm.aiAgentIsEnabled = $$v
              },
              expression: "aiAgentIsEnabled",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.listByChatLog,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "calc(75vh - 120px)",
                "overflow-x": "auto",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "團名", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.travelName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "發問人", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.userName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "QA的日期時間",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createdTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "Q的問題", "min-width": "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.questions))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "A的答案", "min-width": "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.answers))])]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.listQueryByChatLog.total > 0,
                expression: "listQueryByChatLog.total > 0",
              },
            ],
            attrs: {
              layout: "prev, pager, next",
              total: _vm.listQueryByChatLog.total,
              page: _vm.listQueryByChatLog.page,
              limit: _vm.listQueryByChatLog.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQueryByChatLog, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQueryByChatLog, "limit", $event)
              },
              pagination: function ($event) {
                return _vm.getChatLogs(_vm.agencyCode)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading || _vm.aiLoading,
              expression: "listLoading || aiLoading",
            },
          ],
          attrs: {
            top: "5vh",
            title: "設定QA內容",
            visible: _vm.dialogVisibleBySetQA,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleBySetQA = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { model: _vm.formBySetQA } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "content" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "請輸入QA內容",
                          disabled: _vm.listLoading || _vm.aiLoading,
                        },
                        model: {
                          value: _vm.formBySetQA.qaPrompt,
                          callback: function ($$v) {
                            _vm.$set(_vm.formBySetQA, "qaPrompt", $$v)
                          },
                          expression: "formBySetQA.qaPrompt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.saveBySetQAPrompt },
                },
                [_vm._v(" 儲 存 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.closeBySetQAPrompt },
                },
                [_vm._v(" 關 閉 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading || _vm.aiLoading,
              expression: "listLoading || aiLoading",
            },
          ],
          attrs: {
            title: "下載問答紀錄",
            visible: _vm.dialogVisibleByDownloadExcel,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleByDownloadExcel = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { model: _vm.formByDownloadExcel } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "選擇時間區間", prop: "dateRange" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerOptions,
                          disabled: _vm.listLoading || _vm.aiLoading,
                        },
                        model: {
                          value: _vm.formByDownloadExcel.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByDownloadExcel, "dateRange", $$v)
                          },
                          expression: "formByDownloadExcel.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.enterByDownloadExcel },
                },
                [_vm._v(" 下 載 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.closeByDownloadExcel },
                },
                [_vm._v(" 關 閉 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading || _vm.aiLoading,
              expression: "listLoading || aiLoading",
            },
          ],
          attrs: {
            title: "虛擬人介面設定",
            visible: _vm.dialogVisibleByAiQaUi,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleByAiQaUi = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { model: _vm.formByAiQaUi } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "靜態圖片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "JPG / PNG / GIF 網址" },
                        model: {
                          value: _vm.formByAiQaUi.idleImageUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByAiQaUi, "idleImageUrl", $$v)
                          },
                          expression: "formByAiQaUi.idleImageUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "開場影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "進站自動播放影片網址" },
                        model: {
                          value: _vm.formByAiQaUi.openingVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByAiQaUi, "openingVideoUrl", $$v)
                          },
                          expression: "formByAiQaUi.openingVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "回答影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "AI 回答中循環影片網址" },
                        model: {
                          value: _vm.formByAiQaUi.replyVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByAiQaUi, "replyVideoUrl", $$v)
                          },
                          expression: "formByAiQaUi.replyVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.saveByAiQaUi },
                },
                [_vm._v(" 保 存 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    disabled: _vm.listLoading || _vm.aiLoading,
                  },
                  on: { click: _vm.closeByAiQaUi },
                },
                [_vm._v(" 關 閉 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }